<template>
<confirm-base @showErrorModal="$emit('showErrorModal', $event)" @showLoginModal="$emit('showLoginModal', $event)">
  <template scope="prop">
    <div class="form-group p-3">
      <label for="EventTitle" co-3>イベント名・イベントタイトル<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.event_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventTeacher">講師名（活動名）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.lecturer_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="Event-date-input" class="col-form-label">開催日<span class="attention">※</span></label>
      <pre class="font-weight-bold">{{ prop.item.event_date }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="Event-date-public-input" class="col-form-label">開催日(一覧表示用)<span class="attention">※</span></label>
      <p v-if="prop.item.event_date_public" class="font-weight-bold">{{ prop.item.event_date_public }}</p>
      <pre v-else class="font-weight-bold">{{ prop.item.event_date_public_multi }}</pre>
      <pre v-if="!prop.item.event_date_public" class="font-weight-bold">最終開催日の23:59まで掲載されます。</pre>
    </div>
    <div v-if="prop.item.event_date_public" class="form-group p-3">
      <label for="Event-dateEnd-input" class="col-form-label">掲載終了日<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.endDate }}</p>
    </div>
    <div class="form-group p-3">
      <p for="EventPlace">開催場所・住所<span class="attention">※</span></p>
      <p class="font-weight-bold">{{ prop.fullAddress + prop.item.venue.venue_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventTel">問い合わせ先電話番号</label>
      <p class="font-weight-bold">{{ prop.item.inquiry.tel }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventMail">問い合わせ先メールアドレス<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.inquiry.email }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventURL">会場ホームページ（アクセス方法）</label>
      <p class="font-weight-bold">{{ prop.item.venue.homepage }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventBlog">講師ホームページ・ブログ記事URL</label>
      <p class="font-weight-bold">{{ prop.item.lecturer_url }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventDes">イベントの詳細<span class="attention">※</span></label>
      <pre class="font-weight-bold">{{ prop.item.description }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="EventDes">参加費<span class="attention">※</span></label>
      <pre class="font-weight-bold">{{ prop.item.fee }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="AppURL">お申し込みURL</label>
      <p class="font-weight-bold">{{ prop.item.entry_url }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventParking">駐車場有無</label>
      <p class="font-weight-bold">{{ prop.item.parking }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventParking">撮影予定組数 （お客様には公開されません）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.participant }}</p>
    </div>
    <div class="form-group p-3">
      <label class="mr-sm-2" for="EventParking">主催者 （お客様には公開されません）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.sponsor }}</p>
    </div>
    <div class="form-group p-3" v-if="prop.item.sponsor === 'あり'">
      <label for="EventSponsor">主催者名 （お客様には公開されません）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.sponsor_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventInputFile">イベント画像アップロード</label>
      <div class="row">
        <image-item v-for="f in prop.item.images.filter(i => i !== '')" :key="f" :image="f"/>
      </div>
    </div>

    <div class="form-group p-3">
      <label for="EventPublish">公開設定<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.published }}</p>
    </div>
  </template>
</confirm-base>
</template>

<script>
import ConfirmBase from '../ConfirmBase.vue'
import ImageItem from 'components/lecturer/ImageItem'
export default {
  components: {
    ConfirmBase,
    ImageItem
  }
}
</script>



// WEBPACK FOOTER //
// EventConfirm.vue?2c646fc6